import React from "react";
import { Col, Row, Tabs, Tab } from "react-bootstrap";

import one from "../../assets/waterpurifier/one.jpeg";
import two from "../../assets/waterpurifier/two.jpeg";
import three from "../../assets/waterpurifier/three.jpeg";
import four from "../../assets/waterpurifier/four.jpeg";
import five from "../../assets/waterpurifier/five.jpeg";
import six from "../../assets/waterpurifier/six.jpeg";
import seven from "../../assets/waterpurifier/seven.jpeg";
import eight from "../../assets/waterpurifier/eight.jpeg";
import nine from "../../assets/waterpurifier/nine.jpeg";

import oneK from "../../assets/kitchenchimney/one.jpeg";
import twoK from "../../assets/kitchenchimney/two.jpeg";
import threeK from "../../assets/kitchenchimney/three.jpeg";
import fourK from "../../assets/kitchenchimney/four.jpeg";
import fiveK from "../../assets/kitchenchimney/five.jpeg";
import sixK from "../../assets/kitchenchimney/six.jpeg";

import oneM from "../../assets/modularkitchen/one.jpeg";
import twoM from "../../assets/modularkitchen/two.jpeg";
import threeM from "../../assets/modularkitchen/three.jpeg";
import fourM from "../../assets/modularkitchen/four.jpeg";
import fiveM from "../../assets/modularkitchen/five.jpeg";
import sixM from "../../assets/modularkitchen/six.jpeg";

function ProductComponent() {
  return (
    <div className="product-div">
      <h1>Explore Products</h1>
      <button className="btn btn-custom">View All</button>
      <br />
      <br />

      <Tabs defaultActiveKey="one" id="uncontrolled-tab-example">
        <Tab eventKey="one" title="Water Purifier">
          <Row>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={one} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={two} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={three} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={four} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={five} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={six} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={seven} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={eight} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={nine} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="two" title="Kitchen Chimney">
          <Row>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={oneK} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={twoK} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={threeK} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={fourK} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={fiveK} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={3} className="product">
              <center>
                <img src={sixK} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="three" title="Modular Kitchen">
          <Row>
            <Col xs={12} md={6} lg={4} className="product">
              <center>
                <img src={oneM} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={4} className="product">
              <center>
                <img src={twoM} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={4} className="product">
              <center>
                <img src={threeM} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={4} className="product">
              <center>
                <img src={fourM} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={4} className="product">
              <center>
                <img src={fiveM} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
            <Col xs={12} md={6} lg={4} className="product">
              <center>
                <img src={sixM} className="img-fluid img-service" alt="..." />
              </center>
            </Col>
          </Row>
        </Tab>
      </Tabs>
      {/* <Row>
        <Col xs={12} md={6} lg={4} className="product">
          <img src={ph} className="img-fluid img-service" alt="..." />
          
        </Col>
        <Col xs={12} md={6} lg={4} className="product">
          <img src={ph} className="img-fluid img-service" alt="..." />
        </Col>
        <Col xs={12} md={6} lg={4} className="product">
          <img src={ph} className="img-fluid img-service" alt="..." />
        </Col>
      </Row> */}
      <br />
      <center></center>
    </div>
  );
}

export default ProductComponent;
